<template>
  <div class="pokemon">
    <h1>Search for a Pokemon!</h1>

    <div v-if="!isBuildingSearchIndex">
      <autocomplete
        class="autocomplete"
        ref="autocomplete"
        placeholder="pokemon name.."
        :source="this.searchIndex"
        initialValue="pikachu"
        results-property="results"
        results-display="name"
        @selected="fetchPokemon">
      </autocomplete>
    </div>

    <div class="card" v-if="!isFetchingPokemon && pokemon">
      <h2>{{ pokemon.name | capitalize }}</h2>
      <img :src="pokemon.sprites.front_default" :alt="pokemon.name">
      <table>
        <tr v-for="stat in pokemon.stats" :key="stat.id">
          <td class="stat__name">{{ stat.stat.name }}</td>
          <td class="stat__value">{{ stat.base_stat }}</td>
        </tr>
      </table>
    </div>
    <div v-else>
      loading...
    </div>
  </div>
</template>

<script>
import Autocomplete from 'vuejs-auto-complete'

export default {
  name: 'Pokemon',

  components: {
    Autocomplete,
  },

  filters: {
    capitalize: function (value) {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    }
  },

  data () {
    return {
      isFetchingPokemon: false,
      isBuildingSearchIndex: false,
      pokemon: null
    }
  },

  methods: {
    fetchPokemon(pokemon) {
      const pokemonName = pokemon ? pokemon.display : 'pikachu'
      const getPokemonByName = this.$http.get('https://pokeapi.co/api/v2/pokemon/' + pokemonName)
        .then(response => (this.pokemon = response.data))

      this.isFetchingPokemon = true
      Promise.all([getPokemonByName]).finally(() => {
        this.isFetchingPokemon = false
      })
    },

    buildSearchIndex() {
      const getAllPokemon = this.$http.get('https://pokeapi.co/api/v2/pokemon/?limit=9999')
        .then(response => (this.searchIndex = response.data.results))

      this.isBuildingSearchIndex = true
      Promise.all([getAllPokemon]).finally(() => {
        this.isBuildingSearchIndex = false
      })
    }
  },

  updated() {
    if (this.pokemon) {
      console.log('this.pokemon', this.pokemon)
    }
  },

  created() {
    this.fetchPokemon()
    this.buildSearchIndex()
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
a {
  color: #42b983;
}
table {
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
}
tr {
  border-bottom: 1px solid rgba(0,0,0, .15);
}
td {
  padding: .25rem;
}
.stat__name {
  text-align: right;
  font-weight: bold;
}
.stat__value {
  text-align: left;
}
.card {
  border-radius: 3px;
  border: 1px solid rgba(0, 0, 0, .15);
  max-width: 25rem;
  margin: 2rem auto;
}
.autocomplete {
  max-width: 25rem;
  margin: auto;;
}
</style>



// WEBPACK FOOTER //
// src/components/Pokemon.vue